import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  adCardMetrics: {
    marginTop: 16
  }
})

export default useStyles
